<!-- オプション項目マスタ　新規登録画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="wopkm">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>オプション項目マスタ<span>新規</span></h2>
			<ul class="contntMenu">
				<li class="onCancel" v-on:click="onCancel">戻る</li>
			</ul>
			<!-- ▽  -->
			<section class="inputArea">
				<div class="btnLst">
					<button class="confBtn" v-on:click="onConfirmRegisterModalOpen">登録</button>
				</div>
				<table class="inputTbl">
					<thead>
						<tr>
							<th>項目名称</th>
							<td>登録内容</td>
						</tr>
					</thead>
					<tbody>
						<tr>
							<th>分類</th>
							<td>
								<select v-model="opbr" v-on:change="onChange">
									<option value="">選択してください</option>
									<option v-for="list in listsOPBR" v-bind:value="list.OPBR" v-bind:key="list.OPBR">
										{{list.BRNM}}
									</option>
								</select>
							</td>
						</tr>
						<tr>
							<th>並び</th>
							<td><input type="text" v-model.number="sort" maxlength="2" placeholder="XX"></td>
						</tr>
						<tr>
							<th>名称</th>
							<td><input type="text" v-model="opnm" placeholder="名称"></td>
						</tr>
						<tr>
							<th>内部名称</th>
							<td><input type="text" v-model="nbnm" placeholder="内部名称"></td>
						</tr>
						<tr>
							<th>予約枠</th>
							<td>
								<select v-model="waku">
									<option value="">予約枠なし</option>
									<option v-for="list in listsWAKU" v-bind:value="list.WAKU" v-bind:key="list.WAKU">
										{{list.WKNM}}
									</option>
								</select>
							</td>
						</tr>
						<!--オプション分類が択一式の時に表示-->
						<tr v-if="trkb == '1'">
							<th>初期値チェック</th>
							<td>
								<ul class="checkLst">
									<li><label for="wopkmCheck" class="checkbox"><input type="checkbox" id="wopkmCheck" v-model="dffg" true-value="1" false-value="0"><span></span></label></li>
								</ul>
							</td>
						</tr>
					</tbody>
				</table>
			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.validationError.isShow" v-on:close="onValidationErrorModalClose">
			<dt slot="modal-header">入力エラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.validationError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onValidationErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
		<modalWindow v-show="modal.confirmRegister.isShow" v-on:close="onConfirmRegisterModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
			<errorMessageBox :errorMessages="modal.confirmRegister.messages"></errorMessageBox>
			 <ul class="btnLst">
					<li><button v-on:click="onRegister">OK</button></li>
					<li><button v-on:click="onConfirmRegisterModalClose">キャンセル</button></li>
				</ul>
			</dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>

<script>
	import { WOPKMRegisterApi } from '@/api'
	import { WOPKMRegisterFirstDisplayApi } from '@/api'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
	import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWOPKMRegister',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			errorMessageBox: ErrorMessageBox,
			// モーダルウィンドウ
			modalWindow: ModalWindow
		},    
		data() {
			return {
				// 分類プルダウン
				listsOPBR: [],
				// 予約枠プルダウン
				listsWAKU: [],
				// オプション分類コード
				opbr: '',
				// 順序
				sort: '',
				// 名称
				opnm: '',
				// 内部名称
				nbnm: '',
				// 枠
				waku: '',
				// 初期チェック
				dffg: '',
				// 登録方法
				trkb: '',
				// モーダルウィンドウ
				modal: {
					validationError: {
						messages: [],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					},
					confirmRegister: {
						messages: [
							'登録しますか？'
						],
						isShow: false
					}
				},
			}
		},
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWOPKMRegister::created Start')

			// 非同期通信(分類、予約枠のプルダウン表示)
			WOPKMRegisterFirstDisplayApi.RegisterFirstDisplay({
				token: this.$store.state.auth.token,
				ircd: this.$store.state.auth.ircd
			}).then(({ responce }) => {
				this.listsOPBR = responce.data.listOPBR          
				this.listsWAKU = responce.data.listWAKU
			}).catch(() => {
				// システムエラー時
				this.onSystemErrorModalOpen()
			}).finally(() => {
				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::created End')
			})
		},
		methods: {
			onChange: function () {

				this.dffg = ''

				for (var i = 0; i < this.listsOPBR.length; i++ ) {
					if (this.opbr == this.listsOPBR[i].OPBR) {
						this.trkb = this.listsOPBR[i].TRKB
					}
				}
			},
			// 登録用
			onRegister: function () {
				UtilityConsoleLog.consoleLog("MasterWOPKMRegister::onRegister Start") 

				// 文字列になっている場合は数値に変換
				var tempSort = this.checkNumber(this.sort)

				WOPKMRegisterApi.Register({
					token: this.$store.state.auth.token,
					ircd: this.$store.state.auth.ircd,
					opbr: this.opbr,
					sort: tempSort,
					opnm: this.opnm,
					nbnm: this.nbnm,
					dffg: this.dffg,
					waku: this.waku 
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// 登録確認モーダルを閉じる
						this.onConfirmRegisterModalClose()

						// 登録完了モーダルを開く
						this.$router.push("/MasterWOPKMRegisterDone")

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()

						// 入力項目でのエラー
					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_INPUTSIMPLEITEM
											|| responce.data.errorCode == ErrorCodes.ERRORCODE_CORRECTION) {
						this.onValidationErrorModalOpen(responce.data.errorMessagesList)
					}
					
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onRegister End')
				})
			},
			// 一覧表示画面に戻る
			onCancel: function () {
				UtilityConsoleLog.consoleLog("MasterWOPKMRegister::onCancel Start")

				this.$router.push("/MasterWOPKMList")

				UtilityConsoleLog.consoleLog("MasterWOPKMRegister::onCancel End")
			},
			// Number型がString型になっていた場合数値に直して返す
			checkNumber: function (value0) {

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::checkNumber Start')

				var tempType = typeof value0
				var tempValue = 0

				if (tempType == 'number') {
					tempValue = value0
				} else {

					var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/)
					var flagNumber = regexp.test(value0)

					// 文字列型の数値ではないとき
					if (!flagNumber) {
						tempValue = -1
					} else {
						tempValue = Number(value0)
					}
				}

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::checkNumber End')

				return tempValue
			},
			// バリデーションエラーモーダルとしてエラーモーダルを開く
			// errorMessagesは文字列配列であること
			// errorMessages = [
			//  'エラーメッセージ'
			// ]
			onValidationErrorModalOpen: function (errorMessages) {
				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onValidationErrorModalOpen Start')

				var tempMessages = [
					'入力エラーです。',
					'以下の内容をもう一度ご確認ください'
				]
				
				errorMessages.forEach((item)=>{
					tempMessages.push(item)
				})

				this.modal.validationError.messages = tempMessages
				this.modalOpen('validationError')

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onValidationErrorModalOpen End')
			},
			// バリデーションエラーモーダルとしてエラーモーダルを閉じる
			onValidationErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onValidationErrorModalClose Start')

				this.modalClose('validationError')

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onValidationErrorModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push("/AdminLogin")

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onSystemErrorModalClose End')
			},
			// 登録確認モーダルを開く
			onConfirmRegisterModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onConfirmRegisterModalOpen Start')

				// 整数型の型を確認する
				var tempSort = this.checkNumber(this.sort)
				if(tempSort == -1) {
					this.onValidationErrorModalOpen(
						['並びは半角数字で入力してください。'])
					return
				}

				this.modalOpen('confirmRegister')

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onConfirmRegisterModalOpen End')
			},
			// 登録確認モーダルを閉じる
			onConfirmRegisterModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onConfirmRegisterModalClose Start')

				this.modalClose('confirmRegister')

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::onConfirmRegisterModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWOPKMRegister::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WOPKM/MasterWOPKMRegister.vue